import { combineEpics } from 'redux-observable'
import { loginEpic } from './Login/LoginEpic.js'
import { SyncChargebeeStateEpic } from './SyncChargebeeState/SyncChargebeeStateEpic.js'
import { FetchUserIfPresentEpic } from './UpdateUserIfPresent/FetchUserIfPresentEpic.js'

export const authenticationEpics = combineEpics(loginEpic, FetchUserIfPresentEpic, SyncChargebeeStateEpic)
